// Expose getTextsPlayerboards globally
window.getTextsPlayerboards = getTextsPlayerboards;

export function getTextsPlayerboards() {
    return {
        ALCHEMIST_SPEC: {
            name: _("Alchemist"),
            description: _("He has 4 unique alchemist-skills related to potions, each usable once per game during his turn."),
          },
          ALCHEMIST_GEN: {
            name: _("Hero"),
            description: _("This is a neutral character without special skills."),
          },
          ASSASSIN_SPEC: {
            name: _("Assassin"),
            description: _("She is the only one with an additional hand slot, so she can carry up to 5 active objects. The upper hand-slot is also never affected by the “no hand” restriction."),
          },
          ASSASSIN_GEN: {
            name: _("Heroine"),
            description: _("This is a neutral character without special skills."),
          },
          NOBLEMAN_SPEC: {
            name: _("Nobleman"),
            description: _("Each of his 4 active item slots has a skill available from the start of the game, which remains usable only if the slot stays empty."),
          },
          NOBLEMAN_GEN: {
            name: _("Hero"),
            description: _("This is a neutral character without special skills."),
          },
          MERCHANT_SPEC: {
            name: _("Merchant"),
            description: _("She has a Merchant-Token, that she can each turn place on any item in the forge (or on the potions-stack). Once another player takes the marked item, the merchant herself can take a Class 1 item or 1 potion."),
          },
          MERCHANT_GEN: {
            name: _("Heroine"),
            description: _("This is a neutral character without special skills."),
          },
          IRONCLAD_SPEC: {
            name: _("Ironclad"),
            description: _("He starts with 2 dice and an extra heart."),
          },
          IRONCLAD_GEN: {
            name: _("Hero"),
            description: _("This is a neutral character without special skills."),
          },
          ROGUE_SPEC: {
            name: _("Rogue"),
            description: _("She has 4 stronger actions that she can use once per game each."),
          },
          ROGUE_GEN: {
            name: _("Heroine"),
            description: _("This is a neutral character without special skills."),
          },
    };
  }

  export function getTextsKings() {
    return {
        K1: {
          name: _("Queen Annely"),
          type: _("Queen"),
        },
        K2: {
          name: _("Annely the Sublime"),
          type: _("Queen"),
        },
        K3: {
          name: _("King Fraus"),
          type: _("King"),
        },
        K4: {
          name: _("Fraus the Mad"),
          type: _("King"),
        },
        K5: {
          name: _("King Ludus"),
          type: _("King"),
        },
        K6: {
          name: _("Ludus the Mighty"),
          type: _("King"),
        },
        K7: {
          name: _("Queen Tessara"),
          type: _("Queen"),
        },
        K8: {
          name: _("Tessara the Cunning"),
          type: _("Queen"),
        },
    };
  }

  export function getTextsActions() {
    return {
        ACTION_KING: {
            name: _("Fight King"),
            description: {
                1: _("Fight the king/queen."),
                2: _("If you win, you win the game."),
                3: _("Guard actions by other players make the king stronger by 4 each."),
              },
        },
        ACTION_HEAL: {
            name: _("Heal"),
            description: {
                1: _("Regain all of your hearts."),
              },
        },
        ACTION_FIGHT_01: {
            name: _("Fight Class 1"),
            description: {
                1: _("Fight the Class 1 creature."),
                2: _("If you win, you can take 1 Class 1 item (or 1 potion) and then craft once."),
              },
        },
        ACTION_GUARD: {
            name: _("Guard"),
            description: {
                1: _("Take 1 Class 1 item (or 1 potion)."),
                2: _('This round the king has "+4 Strength".'),
              },
        },
        ACTION_FIGHT_02: {
            name: _("Fight Class 2"),
            description: {
                1: _("Fight the Class 2 creature."),
                2: _("If you win, you can take 1 Class 2 item (or 2 potions)."),
              },
        },
        ACTION_CRAFT: {
            name: _("Craft"),
            description: {
                1: _("You may craft up to 2 times."),
                2: _("To craft can be:"),
                3: _('"Combine 2 items"'),
                4: _('"Enhance 1 item (Class 2 or 3)"'),
                5: _('"Trade 1 Class X item for X potions"'),
              },
        },
        ACTION_FIGHT_03: {
            name: _("Fight Class 3"),
            description: {
                1: _("Fight the Class 3 creature."),
                2: _("If you win, you can take 1 Class 3 item (or 3 potions)."),
              },
        },
        ACTION_ROGUE_01: {
            name: _("Theft"),
            description: {
                1: _("Rogue Action! You can only use this once per game."),
                2: _("Take 2 Class 1 items (or potions) from the forge."),
              },
        },
        ACTION_ROGUE_02: {
            name: _("Ambition"),
            description: {
                1: _("Rogue Action! You can only use this once per game."),
                2: _("Regain 1 heart."),
                3: _("Take 1 Class 1 item."),
                4: _("You may craft 1 time."),
              },
        },
        ACTION_ROGUE_03: {
            name: _("Cunning"),
            description: {
                1: _("Rogue Action! You can only use this once per game."),
                2: _("Fight the Class 3 creature."),
                3: _("You have 6 additional fighting power this turn."),
                4: _("If you win, you can take 1 Class 3 item (or 3 potions)."),
              },
        },
        ACTION_ROGUE_04: {
            name: _("Bribery"),
            description: {
                1: _("Rogue Action! You can only use this once per game."),
                2: _("Fight the king/queen."),
                3: _("You have 2 extra speed this turn."),
                4: _("If you win, you win the game."),
                5: _("Guard actions by other players make the king stronger by 4 each."),
              },
        },
    };
  }

  export function getTextsAlchemistTokens() {
    return {
        ALCHEMIST_TOKEN_01: {
            name: _("Alchemist Skill: Dangerous Experiment"),
            description: _("Lose as many of your active hearts as you like, to get that many potions"),
        },
        ALCHEMIST_TOKEN_02: {
            name: _("Alchemist Skill: Research"),
            description: _("Look at the top 3 cards from the potion pile and put them back in your chosen order"),
        },
        ALCHEMIST_TOKEN_03: {
            name: _("Alchemist Skill: Reproduction"),
            description: _("Take one potion of your choice from the discard pile"),
        },
        ALCHEMIST_TOKEN_04: {
            name: _("Alchemist Skill: Expert"),
            description: _("This turn, you can use two potions (instead of only one)"),
        },
    };
  }

  export function getTextsSkills() {
    return {
      D6: {
        name: _('Six-sided dice'),
        },
      D12: {
        name: _('Twelve-sided dice'),
      },
      REROLL_1s: {
        name: _('Reroll all 1s'),
      },
      REROLL_2s: {
        name: _('Reroll all 2s'),
      },
      REROLL_3s: {
        name: _('Reroll all 3s'),
      }, 
      ENEMY_REROLL_5s: {
        name: _('Enemy must reroll all 5s (on six-sided dice)'),
      }, 
      ENEMY_REROLL_6s: {
        name: _('Enemy must reroll all 6s (on six-sided dice)'),
      }, 
      REROLL: {
        name: _('Reroll a die'),
      }, 
      RESTART: {
        name: _('Restart the fight'),
      }, 
      BASESTRENGTH: {
        name: _('Base strength'),
      }, 
      BASESTRENGTH_IF_MONSTER: {
        name: _('Extra base strength if you fight a creature'),
      }, 
      SPEED: {
        name: _('Speed (turn order, ignore restrictions)'),
      }, 
      SHIELD: {
        name: _('Armor (Lose fewer hearts)'),
      }, 
      SWITCH_MONSTER: {
        name: _('Switch the creature'),
      }, 
      JOKER_1: {
        name: _('Class 1 crafting joker'),
      }, 
      JOKER_2: {
        name: _('Class 2 crafting joker'),
      },
      GET_POTION: {
        name: _('and get a potion when combining with it'),
      }, 
      EXTRADAMAGE: {
        name: _('Extradamage (only for heart loss, not fighting power)'),
      }, 
      D6xHEARTS: {
        name: _("Has as many six-sided dice as the player's active hearts"),
      }, 
      MATCH_D6: {
        name: _('Has as many six-sided dice as the player'),
      }, 
      D6xD6: {
        name: _('Two six-sided dice are multiplied'),
      },
    };
  }

  export function getTextsPotionSkills() {
    return {
      HEAL1: _('Heal one of your lost hearts.'),
      SWITCH_ACTION: _('At the beginning of your turn: Change your selected action and immediately perform the new one.'),
      DAMAGE_HEART: _("Flip one of your fellow player's hearts to the used side. It cannot be their last."),
      UNENHANCE: _('Flip one enhanced item of a fellow player back to its regular side.'),
      LEND_ITEM: _('Borrow one item of your fellow players for this fight.'),
      CRAFT: _('You may craft 1 time.'),
      ENHANCE2: _('Enhance up to 2 items.'),
      TAKE_ITEM_USE_IT: _('Take 1 Class one item. For this turn, you may actively use it even in your bag.'),
      INVENTORY_ITEM_ACTIVE: _('For this fight, you may use one item in your bag as an active item.'),
    };
  }

  export function getTextsRestrictions() {
    return {
      HEAD: {
        name: _('Restriction: Head slot'),
      },
      BODY: {
        name: _('Restriction: Body slot'),
      },
      HAND: {
        name: _('Restriction: Hand slot'),
      },
      DICE: {
        name: _('Restriction: All dice'),
      },
      BASESTRENGTH: {
        name: _('Restriction: Base strength'),
      },
    };
  }

  export function getTextsItemLables() {
    return {
      BODY: _('Armor'),
      FEET: _('Shoes'),
      HEAD: _('Helmet'),
      HAND: _('Weapon'),
      UNDEFINED: _('Accessory'),
      POTION: _('Potion'),
    };
  }